import { Api } from "@configs/api/api";
import apiConfig from "@configs/api/api.config";
import { clearAdminSession } from "@utils/adminAuth";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
var Buffer = require('buffer/').Buffer
const API_LOGIN = "/identity/users/auth";
const API_FETCH_ACCOUNT="/identity/users/profile"
//===============================================
const encodeBase64 = function (rawString: any) {
  return new Buffer(rawString).toString("base64");
};
class BaseApi extends Api {
  public constructor(config: AxiosRequestConfig) {
    super(config);
    this.login = this.login.bind(this);
    this.setAccount = this.setAccount.bind(this)
  }
  public setAccount():Promise<any>{
    return this.get<any>(API_FETCH_ACCOUNT, {
      headers:{
        'Authorization': 'Bearer ' + localStorage.getItem("sid"),
      }
    })
    .then((res: AxiosResponse<any>)=>{
      const {data} = res;
      return data
    })
    .catch((err: AxiosError)=>{
      return err.response?.data
    })
  }

  public login(body: any): Promise<any> {
    clearAdminSession();
    return this.post<any>(API_LOGIN,JSON.stringify({}), {
      headers: {
        'Authorization': `Basic ${encodeBase64(`${body.email}:${body.password}`)}`,
        'Accept': 'application/json',
      },
    })
      .then((response: AxiosResponse<any>) => {
        const { data } = response;
        localStorage.setItem("sid", data.result.sid || data.result.token)
        localStorage.setItem('account', JSON.stringify(data.result))
        if (data.result.role) {
          localStorage.setItem("role", data.result.role)
        }
        return data;
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  }
  
}

const baseApi = new BaseApi(apiConfig);
export default baseApi;
